export default __webpack_public_path__ + "static/media/securityConfig.69337623.png";